import { useState, useEffect } from 'react';
import { shallowEqual } from 'react-redux';

import { useAppSelector } from '../shared/hooks/use-app-selector';
import { getAppSettings } from '../selectors';

function useMerchantSettings() {
  const initialization = useAppSelector(
    (store) => store.initialization as { success?: boolean },
    shallowEqual
  );
  const merchantSettings = useAppSelector(getAppSettings, shallowEqual);
  const [isLoading, toggleLoading] = useState<boolean>(true);

  useEffect(() => {
    if (initialization.success) {
      toggleLoading(false);
    }
  }, [initialization]);

  if (isLoading) {
    return { isLoading, merchantSettings: null };
  }

  return {
    isLoading,
    merchantSettings,
  };
}

export default useMerchantSettings;
